import React from "react";
import PropTypes from "prop-types";
import QuotableTest from "./QuotableTest";
import QuotableGroup from "./QuotableGroup";

class Quotable extends React.Component {
  prices = () => this.quotable.prices();

  render() {
    const {
      quotable,
      allowSelect,
      actions,
      rootGroupActions,
      attempt_id,
      toggleDeleteSelect,
      selectedForDeletion,
      hideCollapsed
    } = this.props;
    if (quotable.type == "test") {
      return (
        <QuotableTest
          ref={ref => (this.quotable = ref)}
          selectedForDeletion={selectedForDeletion}
          toggleDeleteSelect={toggleDeleteSelect}
          allowSelect={allowSelect}
          attempt_id={attempt_id}
          quotable={quotable}
          actions={actions}
          rootGroupActions={rootGroupActions}
        />
      );
    } else {
      return (
        <QuotableGroup
          ref={ref => (this.quotable = ref)}
          selectedForDeletion={selectedForDeletion}
          toggleDeleteSelect={toggleDeleteSelect}
          allowSelect={allowSelect}
          attempt_id={attempt_id}
          quotable={quotable}
          actions={actions}
          rootGroupActions={rootGroupActions}
          hideCollapsed={hideCollapsed}
          initialCollapse={quotable.collapsed}
        />
      );
    }
  }
}

export default Quotable;
